import React from "react";
import { Modal, Row, Col, Button, FormInstance } from "antd";
import styles from "./PersonModals.module.scss";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { usePlanDetailsCtx } from "../../../context/PlanDetailsContext";

type Props = {
  form: FormInstance;
  visible: boolean;
  setVisibility: Function;
  handleRouting: Function;
};

const BenefitsModal: React.FC<Props> = ({
  form,
  visible,
  setVisibility,
  handleRouting,
}) => {
  const { width } = useWindowSize();

  const { tripDetailsInfo } = usePlanDetailsCtx();

  const { firstName } = form.getFieldsValue(["firstName"]);

  const handleContinue = () => {
    setVisibility(false);
    handleRouting();
  };

  return (
    <Modal
      visible={visible}
      className={styles.benefitsContainer}
      centered={width < 992}
      width={width < 992 ? "unset" : "547px"}
      footer={
        <Row justify="center">
          <Col>
            <Button className={styles.continue} onClick={handleContinue}>
              Continue
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center" gutter={[0, 30]}>
        <Col xs={0} lg={3} />
        <Col xs={24} lg={18} className={styles.description}>
          <span className={styles.boldText}>{firstName}</span> may have medical
          benefits that you could take advantage of through our parent company,
          MTM.
        </Col>
        <Col xs={0} lg={3} />

        <Col span={24} className={styles.subDescription}>
          Please call us at {tripDetailsInfo.wandaCustomerCareNumber} if you
          would like to learn more.
        </Col>
      </Row>
    </Modal>
  );
};

export default BenefitsModal;
